import axios from 'axios';
import { getItem, removeAll, removeItem } from './lib/myStore';
import App from './components/app';
import 'style/index.styl';
import { getEncryptedData, getDecryptedData } from './lib/encryption';

// const HTTP_UNAUTHORIZED_CODE = 401;

function processPendingRequests(requestQueue) {
  requestQueue = JSON.parse(requestQueue);
  // requestQueue = JSON.parse(getItem('requestQueue'));
  let promises = [];
  requestQueue.map((req) => {
    let method;
    if (req.method === "PUT") {
      method = 'put';
    }
    if (req.method === 'POST') {
      method = 'post';
    }
    if (req.method === 'DELETE') {
      method = 'del';
    }
    promises.push(axios[method](req.url, req.body));
    // requestQueue.splice(index, 1);
    // a = requestQueue;
    // setItem('requestQueue', JSON.stringify(a));
  });
  return Promise.all(promises)
    .then(() => {
      console.log('All offline request queue has been cleared');
      removeItem('requestQueue');
    });
}

// window.addEventListener('offline', () => {
//   // console.log('offline');
//   alert('You are working offline now. The data will be synced when the internet is back.');
// });

window.addEventListener('online', () => {
  console.log('online');
  //When user is online, get requests from queue and call corresponding APIs
  let requestQueue = getItem('requestQueue');
  if (!Object.keys(requestQueue).length) return;
  processPendingRequests(requestQueue);
});


axios.interceptors.request.use(
  config => {
    // console.log(getEncryptedData,"getEncryptedDatagetEncryptedDatagetEncryptedData");
    /*
      Commenting encryption as file upload and third party apis are not working
    */
    // if (config.data && config.url.search('amazonaws') === -1 && config.url.search('zoop') === -1) {
    //   config['data'] = getEncryptedData(JSON.stringify(config.data));
    // }
    if (config.url.search('amazonaws') === -1 && config.url.search('zoop') === -1) {
      /*
        T1011
        Modified By: Harshavardhan Jadhav
        Modified On: 12 Nov 2020
        Modification console.log commented
      */
      // console.log("trueeeeeeeee",getItem('token'));
      const token = getItem('token').token;
      if (token) {
        config.headers['Authorization'] = token;
      }
      config.headers['Content-Type'] = 'application/json';
      /*
        Bug: T1992 - EN_FN:COLLABORATOR: The clock in the chat is not capturing the actual time.
        Modification: Sent request time in the headers
        By: Devang
        Date: 27/07/2024
      */
      /*
        Bug: T1992 - EN_FN:COLLABORATOR: The clock in the chat is not capturing the actual time.
        Modification: Sent request timezone in the headers
        By: Devang
        Date: 02/08/2024
      */
      config.headers['x-request-time'] = new Date().toUTCString();
      config.headers['x-request-timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } else {
      delete config.headers.authorization;
    }
    /*
      T1011
      Modified By: Harshavardhan Jadhav
      Modified On: 12 Nov 2020
      Modification console.log commented
    */
    // console.log(config);
    return config;
  },
  error => {
    Promise.reject(error);
  });

axios.interceptors.response.use((response) => {
  /*
    Commenting encryption as file upload and third party apis are not working
  */
  // if (response.data && response.data.source && response.data.source.data) {
  //   let decryptedData = getDecryptedData(response.data.source);
  //   response['data'] = decryptedData;
  // }
  return response;
}, (error) => {
  console.log(error, 'Error');
  if (error && error.response && 401 === error.response.status) {
    // window.alert({
    //     title: "Session Expired",
    //     text: "Your session has expired. Would you like to be redirected to the login page?",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#DD6B55",
    //     confirmButtonText: "Yes",
    //     closeOnConfirm: false
    // }, function(){
    removeAll();
    window.location = '/';
    // });
  } else if (error && error.response && 706 === error.response.status) {
    removeAll();
    window.location = '/';
  }
  else {
    return Promise.reject(error);
  }
});


export default App;
